import { type } from 'os';
<template>
  <el-drawer
    title="Historial de servicios inactivados"
    :visible.sync="historicIsVisible"
    @close="onHistoricClose"
    size="70%"
  >
    <el-row>
      <rabbey-table-3
        :loading="loadingAuthorizerData"
        :data="authorizerData"
        :columns="authorizerColumns"
      />
    </el-row>
    <!--
        @rtable-push-action="authorizerActionHandler"
        :actions="authorizerActions"
    -->
  </el-drawer>
</template>

<script>
import {
  SwitcherColumns
  // SwitcherActions
} from "@/views/modules/authorizer/switcher/columns/switcherColumns.js";
export default {
  name: "SemaphoreHistoric",
  props: {
    makeHistoricVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      historicIsVisible: false,
      loadingAuthorizerData: false,
      authorizerData: [],
      authorizerColumns: SwitcherColumns
      //authorizerActions: SwitcherActions
    };
  },
  methods: {
    onHistoricClose() {
      this.$emit("onHistoricClose", false);
    },
    async GetInactiveSemaphoreData() {
      this.loadingAuthorizerData = true;
      await this.$http
        .get("/api/tennos/GetSemaphoreHistoric")
        .then((resp) => {
          //console.log("respuesta de data del semaforo: ", resp);
          this.authorizerData = resp.data;
        })
        .catch((err) => {
          console.error("Error: ", err);
        })
        .finally(() => {
          this.loadingAuthorizerData = false;
        });
    }
  },
  watch: {
    async makeHistoricVisible(val) {
      //console.log(val);
      if (val === true) {
        await this.GetInactiveSemaphoreData();
      }
      this.historicIsVisible = val;
    }
  }
};
</script>

<style scoped></style>
